import React from 'react';
import { toastr } from 'react-redux-toastr';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { State } from 'store/interfaces';
import {
  commonActions,
  ShowRoomModelBV,
  ProductViewModelBV,
  api,
  CartStateModel,
  TrimVarientProductModel,
  ProductListDataModel,
  BuildPriceBodyModelDataModel,
} from 'alg-ecom-frontend-core';
import { bindActionCreators } from 'redux';
import Rotation from 'react-rotation';
import BookTestDriveForm from '../../build-vehicle/action-footer/forms/BookTestDriveForm';
// import enquiryImage from '../../assets/images/enquiry.svg';
import { useDataLoader } from 'react-remote-data-hooks';
// import ProductItem from '../home/ProductItem';
import CarSelection from '../car-selection';

interface CustomProps {
  // images: string[];
  onPopupCancel: any;
  isPage?: boolean;
  productID?: number;
  showroomsList?: ShowRoomModelBV[];
  productDetails?: ProductViewModelBV | undefined;
  cartData: CartStateModel;
  trimList?: TrimVarientProductModel[];
  showModel?: boolean;
}
const BookTestDrivePopUp: React.FunctionComponent<CustomProps> = (
  props: CustomProps
) => {
  const [showTankyou, setShowThankyou] = React.useState<boolean>(false);
  const [showForm, setShowForm] = React.useState<boolean>(false);

  const [tabName, setTabName] = React.useState('All');
  const [modelYear, setModelYear] = React.useState<{ modelyear: number }>({
    modelyear: new Date().getFullYear(),
  });
  const [tabYear, setTabYear] = React.useState(0);

  const [trimList, setTrimList] = React.useState<TrimVarientProductModel[]>();
  const [selectedProduct, setSelectedProduct] = React.useState<
    { id: number; image: string; price: number; title: string } | undefined
  >(undefined);
  const [codeYear, setCodeYear] = React.useState<{
    code: string;
    year: number;
  }>({
    code: '',
    year: 0,
  });
  const [formLoading, setFormLoading] = React.useState<boolean>();

  const { t } = useTranslation();
  const onSubmit = async (dataSubmit: any) => {
    try {
      setFormLoading(true);
      const response = await api.quickAccess.BookTestDrive({
        ...dataSubmit,
        campaignTag: sessionStorage.getItem('campaign') || '',
        businessSource: sessionStorage.getItem('track') || 'Alghanim website',
      });
      if (response.responsecode === 200) {
        setShowThankyou(true);
        // toastr.success('Success', 'Test drive booked successfully');
      } else {
        if (response?.message) {
          toastr.error('Error', response?.message);
        }
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toastr.error('Error', error?.response?.data?.message);
      }
    } finally {
      setFormLoading(false);
    }
  };

  const { data, reload, loaded, loading } = useDataLoader<ProductListDataModel>(
    (year: number, tab: string) => api.build.buildPriceProductList(year, tab),
    [modelYear.modelyear, tabName]
  );

  const {
    data: bodyModelData,
    reload: bodyModelReload,
    loaded: bodyModelLoaded,
    loading: bodyModelLoading,
  } = useDataLoader<BuildPriceBodyModelDataModel>(() => api.build.modelList());

  const onModelYearChange = (value: { modelyear: number }) => {
    setModelYear(value);
    reload(value.modelyear, tabName);
  };

  const onSelectProduct = (
    productID: number,
    image: string,
    price: number,
    title: string
  ) => {
    setSelectedProduct({ id: productID, image, price, title });
  };

  const onSelectedTirm = (code: any, year: any) => {
    setCodeYear({ code, year });
  };

  React.useEffect(() => {
    async function getTrimList() {
      const dataTrim = await api.build.trimList(codeYear?.year, codeYear?.code);
      setTrimList(dataTrim?.productsList);
    }
    getTrimList();
  }, [codeYear]);

  return (
    <>
      <div
        className="fade px-0 show"
        id="compareModal"
        tabIndex={-1}
        style={{ display: 'block' }}
      >
        <div className="m-0 h-100">
          <div className="modal-content rounded-0 h-100 overflow-auto border-0">
            <div className="modal-body p-0">
              <button
                type="button"
                className="position-absolute right-0 top-0 zIndex-1 font-sm bg-gray-200 rounded-circle border-0 p-3 m-3 d-inline-block rounded-close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => props.onPopupCancel()}
              >
                <i className="icon-close text-muted"></i>
              </button>
              {!showTankyou ? (
                <div className="w-100">
                  {selectedProduct ? (
                    <BookTestDriveForm
                      onSubmit={onSubmit}
                      showroomsList={props.showroomsList}
                      productDetails={props.productDetails}
                      image={
                        props.cartData?.productInfo?.combinationInfo[0]
                          ?.combinationMedia[0]?.image
                      }
                      trimList={trimList}
                      showModel={true}
                      backToModel={() => {
                        setShowForm(false);
                        setSelectedProduct(undefined);
                      }}
                      modelYear={modelYear?.modelyear}
                      isLoading={formLoading}
                    />
                  ) : (
                    <div className="container">
                      <div className="row">
                        <CarSelection
                          onSelectComplete={onSelectProduct}
                          onSelectTrim={onSelectedTirm}
                        />
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <div className="thankyou-block py-5 text-center">
                  <div className="py-5">
                    {/* <img src={enquiryImage} alt="thank you" className="mb-4" /> */}
                    <h3 className="text-uppercase mb-3">
                      {t('popup.Thank you for the enquiry')}
                    </h3>
                    <p className="font-normal text-gray-700 mb-4 pb-2">
                      {t('popup.ThankYouText')}
                    </p>
                    <button
                      type="button"
                      onClick={props.onPopupCancel}
                      className="btn btn-primary font-md px-5"
                    >
                      <span className="d-block px-sm-4">
                        {t('popup.BACK TO HOME')}
                      </span>
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapActionsToProps = (dispatch: any) => {
  return bindActionCreators(
    {
      dispatch,
    },
    dispatch
  );
};

const mapStateToProps = (state: State) => {
  return {
    cartData: state.cartState,
  };
};

export default connect(mapStateToProps, mapActionsToProps)(BookTestDrivePopUp);
